/**
 * Vencimento de contrato por OS ao arrastar no Board (informativo).
 */

import { getApiBaseUrl } from '../../../utils/apiConfig';

/**
 * @param {string[]} orderIds
 * @returns {Promise<Record<string, { dateLabel: string, expired: boolean, daysLeft: number }>>}
 */
export async function fetchBoardContratoVencByOrder(orderIds) {
  const ids = Array.isArray(orderIds)
    ? orderIds.map((x) => String(x || '').trim()).filter(Boolean)
    : [];
  if (!ids.length) return {};
  const token = localStorage.getItem('authToken');
  try {
    const res = await fetch(`${getApiBaseUrl()}/api/board/orders/contrato-venc-warning`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ orderIds: ids }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success || !data.byOrder || typeof data.byOrder !== 'object') {
      return {};
    }
    const out = {};
    Object.keys(data.byOrder).forEach((k) => {
      const w = data.byOrder[k];
      if (!w || !w.dateLabel) return;
      out[String(k)] = {
        dateLabel: String(w.dateLabel),
        expired: Boolean(w.expired),
        daysLeft: Number(w.daysLeft),
      };
    });
    return out;
  } catch (_err) {
    return {};
  }
}

/**
 * Anexa contratoVenc em cada item de resultado do OrderStatusModal.
 * @param {Array<{ orderId?: string }>} results
 */
export async function enrichOrderResultsWithContratoVenc(results) {
  const list = Array.isArray(results) ? results : [];
  if (!list.length) return list;
  const ids = list.map((r) => String(r?.orderId || '').trim()).filter(Boolean);
  const byOrder = await fetchBoardContratoVencByOrder(ids);
  if (!Object.keys(byOrder).length) {
    return list.map((r) => ({ ...r, contratoVenc: r.contratoVenc || null }));
  }
  return list.map((r) => {
    const id = String(r?.orderId || '').trim();
    return {
      ...r,
      contratoVenc: byOrder[id] || null,
    };
  });
}
